import MoveForwardIcon from './MoveForwardIcon';

interface Location {
  x: number;
  y: number;
}

interface IProps {
  locationImageNode: Location;
  handleMoveUpDown: (up: boolean) => void;
}

const ModalMoveForward = ({ locationImageNode, handleMoveUpDown }: IProps) => {
  const { x, y } = locationImageNode;
  return (
    <button
      style={{
        top: y - 40,
        left: x + 70
      }}
      className="bg-white px-4 py-1 rounded position-absolute btn"
      onClick={() => handleMoveUpDown(true)}
    >
      <MoveForwardIcon height={20} width={15} />
    </button>
  );
};

export default ModalMoveForward;
